// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CollateralAssetCodeService = {};

CollateralAssetCodeService.getCollateralAssetCodeList = function (userInput) {
  return lossClient({
    url: "/CollateralAsset/Items?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default CollateralAssetCodeService;
